export default {"src":"/_next/static/media/assistant-fixer-with-medium-grey-text-box.c0eafeaf.svg","height":332,"width":269};